<template>
  <header id="page-topbar">
    <div class="navbar-header ps-4 ps-lg-0">
      <div class="d-flex w-100">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link
            to="/"
            class="logo logo-light text-light text-uppercase my-auto"
          >
            <div class="d-flex my-auto header-item">
              <img
                class="my-auto"
                style="margin-right: 16px; max-height:25px"
                src="@/assets/images/logo.svg"
                alt="Grid"
              >
              <h3
                class="my-auto text-white"
                style="font-size: 18px; font-weight: 400"
              >
                Dividend Athlete
              </h3>
            </div>
            <!-- <span class="logo-sm">
              <img
                src="@/assets/images/logo-light.svg"
                alt
                height="22"
              >
            </span>
            <span class="logo-lg">
              <img
                src="@/assets/images/logo-light.png"
                alt
                height="19"
              >
            </span> -->
          </router-link>
        </div>
        <!-- <button
          id="toggle"
          type="button"
          class="btn btn-sm ms-3 me-2 font-size-16 d-lg-none header-item"
          @click="toggleMenu"
        >
          <i class="fa fa-fw fa-bars" />
        </button> -->
        <div class="d-flex d-lg-none small-header h-100 my-auto">
          <h4
            class=" my-auto text-white text-uppercase text-start"
            style="font-size: 16px; font-weight: 400"
          >
            Dividend Athlete
          </h4>
        </div>

        <!-- App Search-->
        <FilterSortSearch />
      </div>

      <div class="d-flex">
        <!-- <b-dropdown
          class="d-inline-block d-lg-none ms-2"
          variant="black"
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          right
        >
          <template v-slot:button-content>
            <i class="mdi mdi-magnify" />
          </template>

          <form class="p-3">
            <div class="form-group m-0">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search ..."
                  aria-label="Recipient's username"
                >
                <div class="input-group-append">
                  <button
                    class="btn btn-primary"
                    type="submit"
                  >
                    <i class="mdi mdi-magnify" />
                  </button>
                </div>
              </div>
            </div>
          </form>
        </b-dropdown> -->

        <!-- <div class="dropdown d-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="toggleDarkMode"
          >
            <i class="bx bx-moon" />
          </button>
        </div>

        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen" />
          </button>
        </div> -->

        <!-- <b-dropdown
          menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
          toggle-class="header-item noti-icon"
          variant="black"
        >
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada" />
            <span class="badge bg-danger rounded-pill">{{
              69
            }}</span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0">
                  Notifications
                </h6>
              </div>
              <div class="col-auto">
                <a
                  href="#"
                  class="small"
                >View All</a>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a
              v-for="(item, index) in 3"
              :key="index"
              href="javascript: void(0);"
              class="text-reset notification-item"
            >
              <div class="media">
                <div class="avatar-xs me-3">
                  <span
                    class="avatar-title bg-primary rounded-circle font-size-16"
                  >
                    <i class="bx bx-cart" />
                  </span>
                </div>
                <div class="media-body">
                  <h6 class="mt-0 mb-1">
                    Judul
                  </h6>
                  <div class="font-size-12 text-muted">
                    <p class="mb-1">
                      Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam, distinctio.
                    </p>
                    <p class="mb-0">
                      <i class="mdi mdi-clock-outline" />
                      3 min ago
                    </p>
                  </div>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top d-grid">
            <a
              class="btn btn-sm btn-link font-size-14 text-center"
              href="javascript:void(0)"
            >
              <i class="mdi mdi-arrow-right-circle me-1" />
              <span key="t-view-more">View More</span>
            </a>
          </div>
        </b-dropdown> -->

        <b-dropdown
          menu-class="dropdown-menu-sm dropdown-menu-end"
          right
          variant="black"
          toggle-class="header-item"
        >
          <template v-slot:button-content>
            <span class="d-none d-xl-inline-block ms-1">{{ profile.name }}</span>
            <i class="mdi mdi-chevron-down" />
          </template>
          <div
            class="px-3 pt-2"
          >
            <div
              class="px-1 pb-1 text-primary"
              style="font-weight: 600; font-size: 15px"
            >
              {{ profile.name }}
            </div>
            <div class="link-item-table px-1 pb-1">
              {{ profile.email }}
            </div>
            <hr
              class="
              my-1"
            >
          </div>

          <b-dropdown-item
            class="dropdown-item text-start text-danger p-0"
            @click="doLogout"
          >
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            />
            Sign Out
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style>
@media (max-width: 991.98px) {
  .small-header{
    display: block;
  }
  .navbar-brand-box {
      display: none;
  }
}

@media (min-width: 991.98px) {
  .small-header{
    display: none;
  }
}

</style>

<script>
// import simplebar from 'simplebar-vue';
import { mapActions, mapState } from 'vuex';
import FilterSortSearch from '@/components/FilterSortSearch.vue';

export default {
  components: {
    FilterSortSearch,
    // simplebar,
  },
  data() {
    return {
      type: 'dark',
      width: 'boxed',
    };
  },
  computed: {
    ...mapState('auth', {
      profile: (state) => state.profile,
    }),
    ...mapState('layout', {
      darkMode: (state) => state.darkMode,
    }),
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'dark':
              document.body.setAttribute('data-topbar', 'dark');
              document.body.removeAttribute('data-layout-scrollable');
              break;
            case 'light':
              document.body.setAttribute('data-topbar', 'light');
              document.body.removeAttribute('data-layout-size', 'boxed');
              document.body.removeAttribute('data-layout-scrollable');
              break;
            case 'colored':
              document.body.setAttribute('data-topbar', 'colored');
              document.body.removeAttribute('data-layout-size', 'boxed');
              break;
            default:
              document.body.setAttribute('data-topbar', 'dark');
              break;
          }
        }
      },
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'boxed':
              document.body.setAttribute('data-layout-size', 'boxed');
              document.body.removeAttribute('data-layout-scrollable');
              break;
            case 'fluid':
              document.body.setAttribute('data-layout-mode', 'fluid');
              document.body.removeAttribute('data-layout-scrollable');
              document.body.removeAttribute('data-layout-size');
              break;
            case 'scrollable':
              document.body.setAttribute('data-layout-scrollable', 'true');
              document.body.removeAttribute('data-layout-mode');
              document.body.removeAttribute('data-layout-size');
              break;
            default:
              document.body.setAttribute('data-layout-mode', 'fluid');
              break;
          }
        }
      },
    },
  },
  methods: {
    ...mapActions('layout', ['toggleDarkMode', 'turnOffDarkMode']),
    toggleMenu() {
      const element = document.getElementById('topnav-menu-content');
      element.classList.toggle('show');
    },
    doLogout() {
      this.turnOffDarkMode();
      setTimeout(() => {
        this.$router.push('/logout');
      }, 1);
    },
    initFullScreen() {
      document.body.classList.toggle('fullscreen-enable');
      if (
        !document.fullscreenElement
        /* alternative standard method */ && !document.mozFullScreenElement
        && !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT,
          );
        }
      } else if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    },
    onFieldChange(fieldId) {
      if (this.$route.name === 'field-detail') {
        this.$router.push(`/fields/${fieldId}`);
      } else if (this.$route.name === 'devices') {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            ...this.filter,
            field_id: fieldId,
            page: 1,
          },
        });
      } else {
        this.$router.push(`/history/${fieldId}`);
      }
    },
  },
};
</script>
